// 3섹션

import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { tableData2 } from '__fakeData__/dataTable';
import AddAPIModal from 'components/modal/api-management/AddApiModal';
import { ChevronLeft } from 'lucide-react';
import MenuPanel from 'page-sections/crm/MenuPanel';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { searchByName } from 'utils/utils';
import UserInfoSection from '../../page-sections/crm/UserInfoSection';

export default function UserInfo() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isLaptop = useMediaQuery(theme.breakpoints.down('lg'));

  const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
  const [leftPanelWidth, setLeftPanelWidth] = useState(1.5);
  const [tableData, setTableData] = useState(tableData2);
  const [openModal, setOpenModal] = useState(false);

  const [searchValue, setSearchValue] = useState('');
  const [filteredItem, setFilteredItem] = useState(tableData);
  useEffect(() => {
    const result = searchByName(tableData, searchValue);
    setFilteredItem(result); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    setLeftPanelWidth(isLeftPanelCollapsed ? 0.4 : 1.5);
  }, [isLeftPanelCollapsed]);

  const customStyle = {
    width: '100%',
    overflow: 'hidden',
  };

  // const navbarHeight = 66;

  return (
    <>
      <AddAPIModal showModal={openModal} setShowModal={setOpenModal} />

      <Box sx={customStyle}>
        <Grid container alignItems={'flex-start'}>
          <Grid
            item
            xs={12}
            container
            direction="row"
            alignItems="flex-start"
            bgcolor={'#ffffff'}
            height={'100%'}
            borderRight={`1px solid #E1E1E1`}
          >
            {/* 왼쪽 패널 */}
            <Grid
              item
              lg={leftPanelWidth}
              xs={12}
              order={isLaptop ? 2 : 0}
              display={'flex'}
              flexDirection={'row'}
              sx={{ overflow: 'hidden' }}
              height={'100%'}
            >
              {/* 왼쪽 메뉴 */}
              <MenuPanel />
            </Grid>

            {/* 중간부분 */}
            <Grid
              container
              item
              lg={12 - leftPanelWidth}
              xs={12}
              bgcolor={'#fafafa'}
              borderLeft={`1px solid #E1E1E1`}
            >
              {/* 중간 내용 */}
              <Grid item lg={12} xs={12}>
                <Box
                  pt={3}
                  pb={3}
                  sx={{
                    borderBottom: `1px solid #E1E1E1`,
                    // height: `calc(100vh - ${navbarHeight}px)`,
                    overflow: 'auto',
                  }}
                >
                  <Box
                    px={isTablet ? 2 : 4}
                    display="flex"
                    flexDirection="column"
                    gap={3}
                  >
                    <ChevronLeft
                      size={28}
                      cursor="pointer"
                      onClick={() => navigate(-1)}
                      color={theme.palette.primary.grey}
                    />
                    <UserInfoSection />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
